import { MenuType } from 'src/app/core/enums/menuType';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class MenuInteractionsService {

  public interactionDone$ =  new Subject<{ itemMenuType: MenuType, route: string }>();

  constructor() { }

  public setMenuInteraction(itemMenuType: MenuType, itemMenuRoute: string) {
    this.interactionDone$.next({ itemMenuType: itemMenuType, route: itemMenuRoute });
  }
}
